/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Error_Load_SessionInputs */

const en_interview_error_load_session = /** @type {(inputs: Interview_Error_Load_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load session. Please try again.`)
};

const de_interview_error_load_session = /** @type {(inputs: Interview_Error_Load_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitzung konnte nicht geladen werden. Bitte versuche es erneut.`)
};

const fr_interview_error_load_session = /** @type {(inputs: Interview_Error_Load_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger la session. Veuillez reessayer.`)
};

const es_interview_error_load_session = /** @type {(inputs: Interview_Error_Load_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar la sesion. Intentalo de nuevo.`)
};

const it_interview_error_load_session = /** @type {(inputs: Interview_Error_Load_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare la sessione. Riprova.`)
};

const nl_interview_error_load_session = /** @type {(inputs: Interview_Error_Load_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessie kon niet worden geladen. Probeer het opnieuw.`)
};

const pl_interview_error_load_session = /** @type {(inputs: Interview_Error_Load_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udalo sie zaladowac sesji. Sprobuj ponownie.`)
};

const fi_interview_error_load_session = /** @type {(inputs: Interview_Error_Load_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istunnon lataaminen epaonnistui. Yrita uudelleen.`)
};

const da_interview_error_load_session = /** @type {(inputs: Interview_Error_Load_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke indlaese session. Proev venligst igen.`)
};

const sv_interview_error_load_session = /** @type {(inputs: Interview_Error_Load_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte ladda sessionen. Foersoek igen.`)
};

/**
* | output |
* | --- |
* | "Failed to load session. Please try again." |
*
* @param {Interview_Error_Load_SessionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_error_load_session = /** @type {((inputs?: Interview_Error_Load_SessionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Error_Load_SessionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_error_load_session(inputs)
	if (locale === "fr") return fr_interview_error_load_session(inputs)
	if (locale === "es") return es_interview_error_load_session(inputs)
	if (locale === "it") return it_interview_error_load_session(inputs)
	if (locale === "nl") return nl_interview_error_load_session(inputs)
	if (locale === "pl") return pl_interview_error_load_session(inputs)
	if (locale === "fi") return fi_interview_error_load_session(inputs)
	if (locale === "da") return da_interview_error_load_session(inputs)
	if (locale === "sv") return sv_interview_error_load_session(inputs)
	return en_interview_error_load_session(inputs)
});